import { Flex, Heading } from '@qga/roo-ui/components';
import { LinkList } from '../../../lib/types';
import { StyledRegionLinks } from '../primitives';

import type { FC } from 'react';

export const Links: FC<LinkList> = ({
  title,
  linkList = [],
  itemRenderer,
  onInteraction = () => {},
  onMenuClick = () => {},
  queryString,
}) => {
  const onClickHandler = (trackingName?: string, href?: string, to?: string) => {
    onInteraction({
      type: 'Footer Navigation',
      value: `${trackingName} Selected`,
    });
    onMenuClick({
      itemText: `Footer ${trackingName} Selected`,
      url: href ?? to ?? '',
    })
  }

  const parsedLinks = linkList.map((linkProps) => {
    const { href, to, usesQueryParams, trackingName } = linkProps;
    const allQueryParams =
      usesQueryParams && queryString ? `?${queryString}` : '';
    return {
      ...linkProps,
      name: String(linkProps.children),
      href: href ? `${href}${allQueryParams}` : '',
      to: to ? `${to}${allQueryParams}` : '',
      onClick: () => onClickHandler(trackingName, href, to),
      color: 'white',
      'data-testid': linkProps['data-testid'],
    };
  });


  return (
    <>
     {itemRenderer && (
        <Flex flexDirection={'column'}>
            <Heading.h3
              mb={4}
              fontSize="lg"
              data-testid={title ? 'region-links-header' : undefined}
              aria-hidden={!title}
              color='white'
            >
              {title ?? <span>&#8203;</span>}
            </Heading.h3>
          {itemRenderer()}
        </Flex>
      )}
      {!itemRenderer && (
        <StyledRegionLinks
          title={title}
          color="white"
          fontSize="lg"
          regions={parsedLinks}
        />
      )}
    </>
  );
};
